module.exports = __webpack_public_path__ + "img/ic_mapsentrance.a68c97b9.svg";